import React from 'react';
import { DataTable } from '@jjj/components';
import { t } from '../../../../../../../../i18n';
import { getColumns } from '../columns';
import { NoTalentFoundWrapper, TableWrapper, Title } from './chooseTalent.style';

export function ChooseTalent({
  talents,
  loading,
  selectedTalent,
  onChange,
  loadData,
  totalCount,
  filter,
  onFilterChange,
}) {
  const getEmptyDataText = () => (
    <NoTalentFoundWrapper>{t('dash.units.unit.my_team.add_talent_modal.no_talent_found_label')}</NoTalentFoundWrapper>
  );

  return (
    <>
      <Title>{t('dash.units.unit.my_team.add_talent_modal.search_talent_label')}</Title>

      <TableWrapper>
        <DataTable
          columns={getColumns(selectedTalent, onChange)}
          dataSource={talents}
          loading={loading}
          total={totalCount}
          isStatefullUrl={false}
          onChange={loadData}
          hideShowingEntries
          hideSelectPage
          hideDisplayPopoverContainer
          locale={{
            emptyText: getEmptyDataText(),
          }}
          pageSize={5}
          defaultPageSize={5}
          paginationPosition="center"
          onFilterChange={onFilterChange}
          filter={filter}
        />
      </TableWrapper>
    </>
  );
}
